/**
 * valumize API for managing deals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ComputeSensitivitiesRequest { 
    /**
     * Step size between discount rate rows in percent (e.g. 2.5 = 2.5%). Server divides by 100 with BigDecimal precision.
     */
    step?: number;
    /**
     * Number of steps on each side of zero; total profiles produced = 2 * steps + 1.
     */
    steps?: number;
    /**
     * Which axis the step/steps sweep across. Defaults to DISCOUNT_RATE_DELTA when omitted.
     */
    paramType?: ComputeSensitivitiesRequest.ParamTypeEnum;
}
export namespace ComputeSensitivitiesRequest {
    export type ParamTypeEnum = 'DISCOUNT_RATE_DELTA' | 'EXIT_MULTIPLE_DELTA' | 'TIMING_IN_QTRS_DELTA' | 'UNDRAWN_MULTIPLE_DELTA';
    export const ParamTypeEnum = {
        DiscountRateDelta: 'DISCOUNT_RATE_DELTA' as ParamTypeEnum,
        ExitMultipleDelta: 'EXIT_MULTIPLE_DELTA' as ParamTypeEnum,
        TimingInQtrsDelta: 'TIMING_IN_QTRS_DELTA' as ParamTypeEnum,
        UndrawnMultipleDelta: 'UNDRAWN_MULTIPLE_DELTA' as ParamTypeEnum
    };
}


